import { request } from "../../apis";

export const apiGetLangList = (params) =>
  request("get", `/language`, params, true);
